import { NgModule } from '@angular/core';
import { ActionReducer, StoreModule } from '@ngrx/store';
import { StateSlice } from '../state-slice';
import { reducer } from './users-reducer';
import { initialUsersState } from './users-state';
import { combineReducers, entityMetaReducer } from '@core/utils/state';
import { EffectsModule } from '@ngrx/effects';
import { UsersEffects } from './users-effects';

@NgModule({
    imports: [
        StoreModule.forFeature(StateSlice.USERS, (reducer as ActionReducer<any, any>), {
            initialState: initialUsersState,
            metaReducers: [entityMetaReducer],
            reducerFactory: combineReducers
        }),
        EffectsModule.forFeature([ UsersEffects ])
    ],
    declarations: []
})
export class UsersStateModule {}
